// extracted by mini-css-extract-plugin
export default {"root":"cPdfoNIoB0gUtDHrFKrw","wrap":"HdrhegVCTu05jDdST8gY","main":"_PorPL2JUeLTxmuUDbB7","label":"PPtB3ijGWNcSFYA0JPnk","tag":"UKHPvaKcAE52pHMOQMkN"};